import React from "react";
import PropTypes from "prop-types";
import { SelectValidator } from "react-material-ui-form-validator";
import MotionChevronDown from "../../Icons/MotionChevronDown";

const EMPValidatedSelectIcon = () => <MotionChevronDown />;

const EMPValidatedSelectField = (props) => {
  const {
    testId,
    menuItems,
    value,
    disabled,
    onChange,
    validators,
    errorMessages,
    name,
  } = props;

  return (
    <SelectValidator
      fullWidth
      onChange={onChange}
      SelectProps={{
        disableUnderline: true,
        IconComponent: EMPValidatedSelectIcon,
        native: true,
        name,
      }}
      inputProps={{ "data-testid": testId, disabled }}
      value={value}
      variant="standard"
      validators={validators}
      errorMessages={errorMessages}
    >
      {menuItems.map((item) => (
        <option
          data-testid={item.id}
          value={item.value}
          key={item.value}
          disabled={item.disabled}
        >
          {item.text}
        </option>
      ))}
    </SelectValidator>
  );
};

EMPValidatedSelectField.propTypes = {
  testId: PropTypes.string,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  validators: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  ),
  errorMessages: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
};

EMPValidatedSelectField.defaultProps = {
  testId: undefined,
  menuItems: [],
  value: "",
  disabled: false,
  onChange: undefined,
  validators: [],
  errorMessages: [],
  name: "",
};

export default EMPValidatedSelectField;
